import React, { useEffect } from 'react';
import './excluir-conta.page.scss';
import { Button } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useHistory } from 'react-router-dom';

function ExcluirContaPage() {

  let history = useHistory();

  useEffect(() => {
    document.body.classList.add('is-login-page');
    return function () {
      document.body.classList.remove('is-login-page');
    };
  }, []);

  const GoBack = () => {
    history?.goBack();
  };

  return (
    <>
      <section className="page excluir-conta">
        <div className="header-excluir">
          <div className="container">
            <div className="flex flex-sp flex-cv">
              <h1 className='flex flex-cv'>
                <Button onClick={GoBack}><ArrowBackIosIcon /></Button>
                Exclusão de Conta
              </h1>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="excluir-box">
            <div className="warning-row">
              <WarningAmberIcon className="warning-icon" />
              <p>
                O aplicativo <strong>iDream</strong> leva a sua privacidade a sério.
                Se você deseja excluir permanentemente a sua conta e todos os dados
                associados (sonhos, diários, imagens geradas e informações pessoais),
                você pode solicitar a exclusão através do nosso canal de atendimento.
              </p>
            </div>

            <div className="info-card">
              <h3 className="flex flex-cv">
                <MailOutlineIcon className="mail-icon" />
                Como solicitar:
              </h3>
              <p>
                Envie um e-mail para <strong>contato@a7apps.com</strong> usando o mesmo
                e-mail que você cadastrou no aplicativo iDream, com o assunto
                <strong> "Solicitação de Exclusão de Conta"</strong>.
              </p>

              <a
                href="mailto:contato@a7apps.com?subject=Solicitação%20de%20Exclusão%20de%20Conta%20-%20iDream&body=Por%20favor%2C%20gostaria%20de%20solicitar%20a%20exclusão%20da%20minha%20conta%20e%20dados%20associados%20ao%20aplicativo%20iDream.%0A%0AMeu%20e-mail%20cadastrado%20no%20app%20é%3A%20"
                className="btn-delete"
              >
                <DeleteForeverIcon />
                Enviar Solicitação de Exclusão
              </a>
            </div>

            <p className="prazo-txt">
              Prazo de processamento: Após a confirmação da sua identidade, todos os seus dados
              serão apagados permanentemente de nossos servidores em até <strong>7 dias úteis</strong>.
              Esta ação é irreversível.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default ExcluirContaPage;
